angular.module('NaviaqWebApp').filter('nlToArray', function () {
    return function (text) {
        if (text) {
            return text.split('\n');
        }

        return text;
    };
});
